import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';

export interface StyledLinkProps {
  onClick?: () => void;

  design?: 'default' | 'primary' | 'error';
  target?: string;
  href: string;
  disabled?: boolean;
  classNames?: string;
  tooltip?: string;

  children?: React.ReactNode;
}

export function StyledLink(props: StyledLinkProps) {
  const { href, onClick, children, disabled } = props;

  const isPrimary = props.design && props.design === 'primary';
  const isError = props.design && props.design === 'error';

  const isDefault = !isPrimary && !isError;

  const tooltipId = uuidv4();

  return (
    <div className="inline-flex">
      {props.tooltip && <Tooltip id={tooltipId}></Tooltip>}

      <a
        href={href}
        onClick={() => onClick && onClick()}
        data-tooltip-id={tooltipId}
        data-tooltip-content={props.tooltip}
        target={props.target}
        className={classNames(
          'flex rounded-full border text-sm font-medium px-4 py-2 shadow-xs select-none', //frame + alignments
          'disabled:opacity-50', //effects

          'outline-offset-1 ring-offset-transparent ring-offset-1 ring-1', //set outline-2 to show outline, always set color

          /** STYLE */
          isPrimary && 'bg-brand-pink outline-brand-pink text-white',
          isPrimary &&
            !disabled &&
            'focus:ring-brand-pink hover:ring-brand-pink',

          isError && 'bg-red-800 outline-red-800 text-white',
          isError && !disabled && 'hover:ring-red-700 focus:ring-red-700',

          isDefault && 'bg-white  ring-transparent outline-gray-500 text-black',
          isDefault && !disabled && 'focus:ring-gray-500 hover:ring-gray-500',

          props.classNames && props.classNames
        )}
      >
        {children}
      </a>
    </div>
  );
}

export default StyledLink;
